import { render, staticRenderFns } from "./Kommissionen.vue?vue&type=template&id=a760a314&scoped=true&"
import script from "./Kommissionen.vue?vue&type=script&lang=js&"
export * from "./Kommissionen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a760a314",
  null
  
)

export default component.exports